<template>  
    <div class="flashpool">
        <flash-message transitionIn="animated swing"></flash-message>
    </div>


</template>
<style>
    .flashpool {
        position: fixed;
        top: 120px;
        right: 20px;
        width: 260px;
        -webkit-perspective: 400px;
        perspective: 400px;
        z-index: 99999;
    }
</style>
<script>
    import 'vue-flash-message/dist/vue-flash-message.min.css';
    export default {
        data() {
            return{

            };
        },
        created() {
            this.$api.bus.on("toast", (e) => {
                this.onToaster(e);
            });
        },
        methods: {
            onToaster(e) {
                this.flash(e.txt, e.success ? "success" : "error", {timeout: 6000});
            }
        },
        watch: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/public_app/elements/Toaster.vue